import { useLayoutEffect, useState } from "react";

export const useIntersectionObserver = (
  ref: React.RefObject<HTMLElement | null>,
  options?: IntersectionObserverInit,
): IntersectionObserverEntry | undefined => {
  const [entry, setEntry] = useState<IntersectionObserverEntry>();
  useLayoutEffect(() => {
    const element = ref.current ?? null;
    const intersectionObserver = new IntersectionObserver((entries) => {
      if (!Array.isArray(entries)) {
        return;
      }
      if (!entries.length) {
        return;
      }
      setEntry(entries[0]);
    }, options);
    if (element) {
      intersectionObserver.observe(element);
    }
    return () => {
      if (element) {
        intersectionObserver.unobserve(element);
      }
    };
  }, [options, ref]);
  return entry;
};
